import { ChangeEvent, useCallback, useMemo } from 'react';

import { Col, Input, Row } from 'antd';

import BoxContainer from '@src/components/BoxContainer';
import Title from '@src/components/BoxContainer/components/Title';
import { KeyValueWidget } from '@src/components/KeyValueWidget';

import { SEARCHABLE_COLUMNS } from '../components/DashboardWidget/transformers/deviationsTaskComplianceTransformer';
import { useSingleFilter } from '../hooks/useSingleFilter';
import { getOrderedSearchableColumns } from './utils';

export const DeviationsTaskComplianceFilter = () => {
  const { widgetFilters, patchOpenWidgetFilterField } = useSingleFilter();

  const orderedFields = useMemo(
    () =>
      getOrderedSearchableColumns(widgetFilters?.widget?.queryParams?.columns, SEARCHABLE_COLUMNS),
    [widgetFilters?.widget?.queryParams?.columns],
  );

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>, key: string) => {
      patchOpenWidgetFilterField(key, e.target.value);
    },
    [patchOpenWidgetFilterField],
  );

  return (
    <BoxContainer>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Title.SubTitle value={widgetFilters?.widget?.title} />
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        {orderedFields.map(({ key }) => {
          const field = widgetFilters?.filters?.[key];
          if (!field) return null;

          return (
            <Col span={24} key={key}>
              <KeyValueWidget
                label={field.label}
                value={
                  <Input
                    onChange={e => onChange(e, field.key ?? key)}
                    value={field.value as string}
                  />
                }
              />
            </Col>
          );
        })}
      </Row>
    </BoxContainer>
  );
};
